import { render } from "./TransactionsDrawer.vue?vue&type=template&id=18f6df85&scoped=true"
import script from "./TransactionsDrawer.vue?vue&type=script&lang=js"
export * from "./TransactionsDrawer.vue?vue&type=script&lang=js"

import "./TransactionsDrawer.vue?vue&type=style&index=0&id=18f6df85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f6df85"]])

export default __exports__